// extracted by mini-css-extract-plugin
export var card = "_oz-0";
export var content = "_oz-2";
export var details = "_oz-3";
export var icon = "_oz-1";
export var iconBlue = "_oz-5";
export var iconBrand = "_oz-4";
export var iconGrayBlue = "_oz-6";
export var iconGreen = "_oz-7";
export var iconIndigo = "_oz-8";
export var iconOrange = "_oz-9";
export var iconPurple = "_oz-a";
export var iconRed = "_oz-b";
export var iconWarning = "_oz-c";